import { MaterialReactTable, MRT_ColumnDef } from 'material-react-table';
import { Box, Paper, Grid, Chip } from "@mui/material";
import { Vendor } from "../helpers/InterfacesServer";
import { VerticalScrollableComponent } from "../layouts/VerticalScrollableComponent";
import { useAppSelector } from '../store/store';

export function ViewVendors() {
    const vendors = useAppSelector(state => state.vendors.value);
    const vendorUsersDict = useAppSelector(state => state.vendorUsersDict.value);
    const vendorInvitationsReportDict = useAppSelector(state => state.vendorInvitationsReportDict.value);
    const columns: MRT_ColumnDef<Vendor>[] = [
        { accessorKey: 'VendorCode', header: 'Vendor Code', size: 150 },
        { accessorKey: 'VendorName', header: 'Vendor Name', grow:1 },
        {
            accessorKey: 'Emails',
            header: 'Emails',
            grow: 1,
            Cell: ({ cell }) => (
                <Box sx={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                    {cell.getValue<string[]>().map((email, idx) => (
                        <Chip color={vendorUsersDict.get(email) == null && !(email.endsWith('totalenergies.com') || email.endsWith('total.com')) ? (vendorInvitationsReportDict.get(email) == null  ? 'warning' : 'secondary') : 'success'} key={idx} label={email} title={vendorInvitationsReportDict.get(email)?.Description} size="small" />
                    ))}
                </Box>
            ),
        },
        {
            accessorFn: (row) => row.IsActive ? 'Active' : "Inactive",
            header: 'Status',
            size: 150,
            Cell: ({ cell }) => (
                <Chip
                    label={cell.getValue<string>()}
                    color={cell.getValue<string>() === 'Active' ? 'success' : 'error'}
                    size="small"
                />
            ),
        }, 
        {
            accessorFn: (row) => row.Emails.find(email => vendorUsersDict.get(email) == null && !(email.endsWith('totalenergies.com') || email.endsWith('total.com'))) == null ? 'All Users Onboarded' : "Pending Users",
            header: 'Onboarding Status',
            size: 190,
        }
    ];



    return (
        <Box className='HorizontalOverFlowContainer'>
            <Paper className="Form">
                <br />
                <VerticalScrollableComponent viewPortHeightOffset={162}>
                    <Grid style={{ padding: 10 }} >
                        {vendors && vendors.length > 0 &&
                            <MaterialReactTable<Vendor> columns={columns} data={vendors} enableColumnResizing enablePagination enableSorting enableColumnFilters
                                mrtTheme={{ baseBackgroundColor: "#ffffff", }} muiTablePaperProps={{ elevation: 0, }}
                            />
                        }
                    </Grid>
                </VerticalScrollableComponent>
                <br />

            </Paper>
        </Box>
    )
}
